<script>
export const VV_BOTTOM_NAV_ROUTES = [
  "/profile",
  "/vv-retail",
  "/point-to-baht",
  "/all-privilege",
  "/manage"
];

// Icons from docs/vv-ui/image-ref/Profile/icon (Figma export)
// stroke="currentColor" so active/inactive สืบทอดสีจาก .vv-bottom-nav__item
const NAV_ICONS = {
  home: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.02 2.84 3.63 7.04C2.73 7.74 2 9.23 2 10.36v7.41C2 20.09 3.89 21.99 6.21 21.99h11.58c2.32 0 4.21-1.9 4.21-4.21V10.5c0-1.21-.81-2.76-1.8-3.45L14.02 2.72c-1.4-.98-3.65-.93-5 .12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 17.99v-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  reward: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.426 14.09V8.837a2.394 2.394 0 0 1 2.393-2.393h14.36a2.394 2.394 0 0 1 2.394 2.393v5.253M2.426 14.09h19.147M2.426 14.09v5.517A2.394 2.394 0 0 0 4.82 22h14.36a2.394 2.394 0 0 0 2.394-2.393v-5.517M12.173 22V6.443M10.967 5.94c.18-.008.345-.102.434-.256.09-.155.088-.345.005-.504-.318-.58-1.433-2.504-2.16-2.925a1.703 1.703 0 0 0-2.303 2.475c.74.427 2.953.423 3.614.41ZM12.632 5.18a.483.483 0 0 0-.005.504c.09.154.255.248.436.256.66.014 2.885.011 3.613-.41a1.703 1.703 0 0 0-1.694-2.955c-.74.427-1.843 2.346-2.16 2.925Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  redeem: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.772 17.383a1.014 1.014 0 0 1 1.438 0 1.017 1.017 0 0 1 0 1.438l-.705.705h1.614a2.234 2.234 0 0 0 2.237-2.238v-1.626c0-.562.455-1.017 1.017-1.017.561 0 1.017.455 1.017 1.017v1.626a4.51 4.51 0 0 1-4.271 4.272h-1.613l.704.704a1.017 1.017 0 0 1-1.438 1.438l-2.44-2.44a1.017 1.017 0 0 1 0-1.44l2.44-2.44ZM11.593 16.27a4.475 4.475 0 1 0-8.95 0 4.475 4.475 0 0 0 8.95 0Zm8.406-7.322a4.475 4.475 0 0 0-8.84-1c-.124.548-.669.891-1.216.767a1.017 1.017 0 0 1-.767-1.216A6.51 6.51 0 0 1 15.524 2.44a6.51 6.51 0 0 1 6.51 6.51c0 3.33-2.502 6.076-5.728 6.463a1.017 1.017 0 0 1-.24-2.02c2.216-.266 3.935-2.155 3.935-4.443ZM.61 8.34V6.71a4.271 4.271 0 0 1 4.271-4.27h1.613l-.705-.706A1.017 1.017 0 0 1 7.227.298l2.44 2.44c.191.19.298.45.298.72 0 .27-.107.529-.298.72l-2.44 2.44a1.017 1.017 0 0 1-1.438-1.44l.704-.703H4.881a2.234 2.234 0 0 0-2.237 2.237V8.34a1.017 1.017 0 0 1-2.034 0Zm13.017 7.93a6.51 6.51 0 1 1-13.018 0 6.51 6.51 0 0 1 13.018 0Z" fill="currentColor"/><path d="M4.8 18.72v-5.28h2.414c.483 0 .898.078 1.245.234.352.156.624.382.815.679.191.291.286.638.286 1.04 0 .398-.095.742-.286 1.034a1.855 1.855 0 0 1-.815.679c-.347.155-.762.234-1.245.234H5.63l.664-.649v2.03H4.8Zm1.494-1.87-.664-.687h1.494c.311 0 .543-.068.693-.204.156-.136.234-.324.234-.566 0-.246-.078-.437-.234-.573-.15-.136-.382-.204-.693-.204H5.63l.664-.686v2.92ZM15.19 11.845a2.94 2.94 0 0 1-1.084-.183 2.517 2.517 0 0 1-.858-.52 2.36 2.36 0 0 1-.563-.789 2.516 2.516 0 0 1-.204-1.027c0-.376.068-.719.204-1.028.136-.315.324-.587.563-.817.244-.23.53-.406.858-.528a2.94 2.94 0 0 1 1.083-.183c.455 0 .861.08 1.218.24.36.16.66.39.9.69l-.887.803a1.585 1.585 0 0 0-.528-.43 1.379 1.379 0 0 0-.634-.148c-.202 0-.387.033-.556.099a1.222 1.222 0 0 0-.436.289 1.312 1.312 0 0 0-.282.435 1.617 1.617 0 0 0-.101.58c0 .21.033.403.101.577.07.174.164.324.282.446.122.122.267.216.436.282.169.066.354.099.556.099.234 0 .445-.05.634-.148.192-.099.368-.242.528-.43l.887.803c-.24.296-.54.526-.9.69-.357.16-.764.24-1.218.24Z" fill="currentColor"/></svg>`,
  profile: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.59 22c0-3.87-3.85-7-8.59-7s-8.59 3.13-8.59 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  retail: `<svg width="24" height="24" viewBox="0 0 214 186" xmlns="http://www.w3.org/2000/svg" aria-label="V logo"><path d="M 35 31 L 36 34 L 43 40 L 57 70 L 61 81 L 68 94 L 89 141 L 129 141 L 168 59 L 171 55 L 176 51 L 134 51 L 128 56 L 118 76 L 118 82 L 120 89 L 122 92 L 135 66 L 142 59 L 154 61 L 147 69 L 124 116 L 120 116 L 105 78 L 88 39 L 85 36 L 79 33 L 69 31 L 69 34 L 85 71 L 92 84 L 106 119 L 110 126 L 116 131 L 116 134 L 108 134 L 103 133 L 97 127 L 56 32 Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"/></svg>`
};

export const VV_REDEEM_ICON = NAV_ICONS.redeem;

export default {
  name: "VvBottomNavigation",
  data() {
    return {
      notchX: null
    };
  },
  computed: {
    tabs() {
      return [
        {
          key: "home",
          label: this.$t("home"),
          route: VV_BOTTOM_NAV_ROUTES[0],
          icon: NAV_ICONS.home
        },
        {
          key: "reward",
          label: this.$t("redeem_text"),
          route: VV_BOTTOM_NAV_ROUTES[3],
          icon: NAV_ICONS.reward
        },
        {
          key: "redeem",
          label: this.$t("redeem"),
          route: VV_BOTTOM_NAV_ROUTES[2],
          icon: NAV_ICONS.redeem
        },
        {
          key: "profile",
          label: this.$t("profile"),
          route: VV_BOTTOM_NAV_ROUTES[4],
          icon: NAV_ICONS.profile
        },
        {
          key: "retail",
          label: this.$t("vv_retail"),
          route: VV_BOTTOM_NAV_ROUTES[1],
          icon: NAV_ICONS.retail
        }
      ];
    },
    activeIndex() {
      const index = this.tabs.findIndex(tab => this.isActive(tab.route));
      return index >= 0 ? index : 0;
    },
    notchStyle() {
      if (this.notchX != null) {
        return { "--notch-x": `${this.notchX}px` };
      }
      const menuCount = this.tabs.length || 1;
      const itemWidth = 100 / menuCount;
      const activeCenter = itemWidth * this.activeIndex + itemWidth / 2;
      return { "--notch-x": `${activeCenter}%` };
    }
  },
  watch: {
    activeIndex() {
      this.$nextTick(() => this.updateNotchPosition());
    }
  },
  mounted() {
    this.$nextTick(() => this.updateNotchPosition());
    window.addEventListener("resize", this.updateNotchPosition);
    window.addEventListener("orientationchange", this.updateNotchPosition);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateNotchPosition);
    window.removeEventListener("orientationchange", this.updateNotchPosition);
  },
  methods: {
    isActive(route) {
      return this.$route.path.includes(route);
    },
    goTo(route) {
      if (this.$route.path != route) this.$router.push(route);
    },
    updateNotchPosition() {
      const nav = this.$refs.nav;
      const items = this.$refs.items;
      if (!nav || !items || !items.length) return;
      const activeBtn = items[this.activeIndex];
      if (!activeBtn) return;
      const navRect = nav.getBoundingClientRect();
      const itemRect = activeBtn.getBoundingClientRect();
      this.notchX = itemRect.left - navRect.left + itemRect.width / 2;
    }
  }
};
</script>

<template>
  <nav
    ref="nav"
    class="vv-bottom-nav"
    :style="notchStyle"
    data-test="vv-bottom-nav"
    :aria-label="$t('vv_bottom_navigation_label')"
  >
    <button
      v-for="tab in tabs"
      ref="items"
      :key="tab.key"
      type="button"
      :class="['vv-bottom-nav__item', { 'is-active': isActive(tab.route) }]"
      :data-test="`vv-bottom-nav-tab-${tab.key}`"
      @click="goTo(tab.route)"
    >
      <span
        class="vv-bottom-nav__icon"
        v-html="tab.icon"
        aria-hidden="true"
      />
      <span class="vv-bottom-nav__dot" aria-hidden="true"></span>
      <span class="vv-bottom-nav__label">{{ tab.label }}</span>
    </button>
  </nav>
</template>

<style lang="scss" scoped>
/*
  Vision Venture — Bottom Navigation
  - แนวทางเดียวกับที่ CrmBottomNavigation เคยใช้ (commit d9ebd1d — ก่อน refactor)
  - ใช้ CSS mask radial-gradient cut notch จริงบน pseudo-element
  - Active dot ลอยเหนือ notch, transition ตำแหน่งด้วย @property --notch-x
*/

.vv-bottom-nav {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: stretch;
  --nav-x-padding: 10px;
  --notch-x: 50%;
  --notch-radius: 18px;
  min-height: calc(78px + env(safe-area-inset-bottom));
  overflow: visible;
  padding: 18px var(--nav-x-padding) calc(8px + env(safe-area-inset-bottom));
  background: transparent;
  filter: drop-shadow(0 -4px 16px var(--primary-color-low));
}

.vv-bottom-nav::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background: var(--bar-color);
  border-radius: 16px 16px 0 0;
  -webkit-mask: radial-gradient(
    circle var(--notch-radius) at var(--notch-x) 0,
    transparent 99%,
    #000 100%
  );
  mask: radial-gradient(
    circle var(--notch-radius) at var(--notch-x) 0,
    transparent 99%,
    #000 100%
  );
  pointer-events: none;
  transition: --notch-x 0.25s ease;
}

@property --notch-x {
  syntax: "<length-percentage>";
  inherits: true;
  initial-value: 50%;
}

@media (max-width: 360px) {
  .vv-bottom-nav {
    --notch-radius: 16px;
  }
}

.vv-bottom-nav__item {
  position: relative;
  z-index: 1;
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border: 0;
  background: transparent;
  color: var(--tab-text-color);
  font-size: var(--font-body);
  line-height: 1.2;
  cursor: pointer;
  isolation: isolate;
}

.vv-bottom-nav__icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;

  :deep(svg) {
    width: 100%;
    height: 100%;
  }
}

.vv-bottom-nav__item.is-active {
  color: var(--primary-color);
  font-weight: 600;
}

.vv-bottom-nav__dot {
  position: absolute;
  top: -18px;
  left: 50%;
  z-index: 2;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: transparent;
  pointer-events: none;
  transform: translateX(-50%);
}

.vv-bottom-nav__item.is-active .vv-bottom-nav__dot {
  background: var(--primary-color);
}

.vv-bottom-nav__label {
  position: relative;
  z-index: 1;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
